(function() {
    $(document).ready(function() {

        const players = {};
        let jsCallbacks = [];
        let jsIsLoading = false;
        let allPlayerIds = [];

        init();

        function init() {
            const clips = $('.c24YoutubeClip');

            if (!clips.length) {
                return;
            }

            initApiClips(clips);
            initSimpleClips(clips);
            checkAutoPlay(clips);
        }

        function initApiClips(clips) {

            const apiClips = clips.filter(':not(.simple)');

            if (!apiClips.length) {
                return;
            }

            if (window.c24Lp.isIos()) {
                loadYoutubeJs();
            }

            apiClips.each(function(_, clipDomElement) {

                const clip = $(clipDomElement);
                const videoId = clip.data('id');

                if (!videoId) {
                    return;
                }

                let settings = clip.data('settings');
                if (!settings) {
                    settings = {
                        'autoplay': 1,
                        'autohide': 2,
                        'border': 0,
                        'wmode': 'opaque',
                        'enablejsapi': 1,
                        'controls': 0,
                        'showinfo': 0,
                        'rel': 0,
                    };
                }

                const playIcon = $('.box24YoutubePlay', clip);
                const playerId = generatePlayerId();

                playIcon.on('click', function() {
                    playIcon.remove();
                    loadYoutubeJs();
                    playApiClip(clip, playerId, videoId, settings);

                    if (window.c24Lp.isIos()) {
                        (function startPlayer() {
                            if (players[playerId]) {
                                players[playerId].playVideo();
                            } else {
                                setTimeout(startPlayer, 20);
                            }
                        })();
                    }
                });
            });
        }

        function initSimpleClips(clips) {
            clips.filter('.simple').each(function (_, domElement) {
                const clip = $(domElement);
                const videoId = clip.data('id');

                if (videoId) {
                    if (window.c24LpIsMobile) {
                        clip.html('<iframe src="https://www.youtube-nocookie.com/embed/' + videoId + '?autohide=2&border=0&wmode=opaque&enablejsapi=1&controls=0&showinfo=0&rel=0" frameborder="0" allowfullscreen></iframe>');
                    } else {
                        clip.html('<span class="box24YoutubePlay"></span>');
                        $('.box24YoutubePlay', clip).on('click', function() {
                            clip.html('<iframe src="https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&autohide=2&border=0&wmode=opaque&enablejsapi=1&controls=0&showinfo=0&rel=0" frameborder="0" allowfullscreen></iframe>');
                            clip.css('background-image', 'none');
                            setTimeout(function() {
                                clip.css('background-color', 'transparent');
                            }, 800);
                        });
                    }
                }
            });
        }

        function loadYoutubeJs() {
            if (jsIsLoading) {
                return;
            }

            jsIsLoading = true;

            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubeIframeAPIReady = function() {

                $(jsCallbacks).each(function(_, func) {
                    func();
                });

                jsCallbacks = {
                    push: function (func) {
                        func();
                    },
                };
            };
        }

        function generatePlayerId() {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let playerId = 'j24Youtube-';

            for (let i = 0; i < 12; i++) {
                playerId += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            allPlayerIds.push(playerId);
            return playerId;
        }

        function playApiClip(clip, playerId, videoId, settings) {

            function onPlayerReady(e) {

                e.target.playVideo();

                const playerElement = document.getElementById(playerId);

                if (playerElement) {

                    $(playerElement).removeData('matomo-ignore');
                    $(playerElement).removeAttr('data-matomo-ignore');

                    window._paq.push(['MediaAnalytics::scanForMedia', clip[0]]);
                }

                players[playerId] = e.target;
            }

            clip.css('background-image', 'none');
            clip.css('background-color', 'black');

            if (clip.data('overlay') && !window.c24LpIsMobile) {
                clip.addClass('overlay');
                clip.append('<div class="overlayBackground"></div><div class="overlayVideo"><div id="' + playerId + '" data-matomo-ignore="1"></div></div>');

                $('.overlayBackground', clip).on('click', function() {
                    clip.removeClass('overlay');
                    $('body').css('overflow', 'auto');
                });

                $('.overlayVideo', clip).on('click', function() {
                    clip.removeClass('overlay');
                    $('body').css('overflow', 'auto');

                    players?.[playerId].stopVideo();
                });

                $('body').css('overflow', 'hidden');

            } else {
                clip.append('<div id="' + playerId + '" data-matomo-ignore="1"></div>');
            }

            settings.origin = window.location.host;

            const playerConfig = {
                height: '100%',
                width: '100%',
                playerVars: settings,
                host: 'https://www.youtube-nocookie.com',
                videoId: videoId,
                events: {
                    'onReady': onPlayerReady,
                },
            };

            jsCallbacks.push(function() {
                new window.YT.Player(playerId, playerConfig);
            });

            setTimeout(function() {
                clip.css('background-color', 'transparent');
            }, 800);
        }

        function checkAutoPlay(clips) {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('ova')) {
                clips.each(function(_, clipDomElement) {

                    const clip = $(clipDomElement);
                    const videoId = clip.data('id');
                    const playIcon = $('.box24YoutubePlay', clip);
                    let settings = clip.data('settings');
                    if (!settings) {
                        settings = {
                            'autoplay': 1,
                            'autohide': 2,
                            'border': 0,
                            'wmode': 'opaque',
                            'enablejsapi': 1,
                            'controls': 0,
                            'showinfo': 0,
                            'rel': 0,
                        };
                    }
                    playIcon.remove();
                    loadYoutubeJs();
                    playApiClip(clip, allPlayerIds[0], videoId, settings);
                    return false;
                });
            }
        }
    });
})();
